import { useTranslation } from "react-i18next";
import { Link, Outlet } from "react-router";
import { LanguageToggle } from "@/components/language-toggle";
import { PublicNavbar } from "./public-navbar";

export default function StorefrontLayout() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-30 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-2 px-4 py-3 sm:gap-4">
          <Link
            aria-label={t("storefront.layout.brand", "La Nueva Carta Digital")}
            className="shrink-0 font-semibold text-sm sm:text-base"
            to="/"
          >
            {t("storefront.layout.brand", "La Nueva Carta Digital")}
          </Link>
          <div className="flex items-center gap-2">
            <LanguageToggle />
            <PublicNavbar />
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-6 sm:py-8">
        <Outlet />
      </main>
    </div>
  );
}
